import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { bindAll, map } from 'lodash-es'

import { IconComponent, Row, Col, VideoItemComponent } from '..'

import './style.scss'

class VideoList extends React.Component {
  constructor(props) {
    super(props)

    const { items } = this.props

    this.state = {
      items,
      dragging: false,
      draggingItem: null,
      isCollapsed: false,
    }

    this.draggingElement = null
    bindAll(
      this,
      'handleMouseEvent',
      'onMouseDown',
      'onMouseEnter',
      'onMouseMove',
      'onMouseUp',
      'toggleSeeAllButton'
    )
  }

  UNSAFE_componentWillReceiveProps(props) {
    this.setState({ items: props.items })
  }

  handleMouseEvent(e) {
    if (this.draggingElement) {
      this.draggingElement.style.top = `${e.pageY + 2}px`
      this.draggingElement.style.left = `${e.pageX + 2}px`
    }
  }

  onMouseDown(e, item, element) {
    const { reorderable } = this.props

    if (reorderable) {
      this.setState({
        dragging: true,
        draggingItem: item,
      })
      this.draggingElement = element
      this.handleMouseEvent(e)
    }
  }

  onMouseEnter(item) {
    const { reorderable } = this.props
    const { dragging, draggingItem, items } = this.state

    if (reorderable && dragging && item !== draggingItem) {
      const index = items.indexOf(draggingItem)
      const newIndex = items.indexOf(item)
      // eslint-disable-next-line
      const newItems = [].concat(items)
      newItems.splice(index, 1)
      newItems.splice(newIndex, 0, draggingItem)
      this.setState({ items: newItems })
    }
  }

  onMouseMove(e) {
    const { dragging } = this.state

    if (dragging) {
      this.handleMouseEvent(e)
    }
  }

  onMouseUp() {
    const { dragging, items } = this.state
    const { onOrderChange } = this.props

    if (dragging) {
      this.setState({
        dragging: false,
        draggingItem: null,
      })
      this.draggingElement.style.top = ''
      this.draggingElement.style.left = ''
      this.draggingElement = null

      onOrderChange(items)
    }
  }

  addVideoButton() {
    const { addVideoButton, columns, onAddVideoButtonClick } = this.props
    if (addVideoButton) {
      return (
        <Col span={Math.round(24 / columns)}>
          <div onClick={onAddVideoButtonClick} className="add-video-button">
            <div className="icon-plus-wrapper">
              <IconComponent name="plus" color="d1e0d4" />
            </div>
          </div>
        </Col>
      )
    }
    return null
  }

  toggleSeeAllButton() {
    this.setState((state) => ({ isCollapsed: !state.isCollapsed }))
  }

  seeAllVideos() {
    const { showAsSingleLine, columns, items: itemsProp } = this.props
    const { items, isCollapsed } = this.state

    if (showAsSingleLine && items.length >= columns) {
      const message = () => {
        const lessOrMore = isCollapsed ? 'less' : 'more'
        return `See ${lessOrMore} videos in spot (${itemsProp.length} videos)`
      }
      return (
        <div className="see-all-videos">
          {/* eslint-disable-next-line */}
          <button
            onClick={this.toggleSeeAllButton}
            className="all-videos-button"
          >
            {message()}
          </button>
        </div>
      )
    }
    return null
  }

  renderVideoItems() {
    const { items, isCollapsed, draggingItem } = this.state
    const { reorderable, showAsSingleLine, columns, addVideoButton } =
      this.props

    let draggingProps = {}
    if (reorderable) {
      draggingProps = {
        onMouseDown: this.onMouseDown,
        onMouseEnter: this.onMouseEnter,
      }
    }

    return map(items, (item, index) => {
      let isHidden = false
      if (showAsSingleLine && !isCollapsed) {
        isHidden = index >= columns - (addVideoButton ? 1 : 0)
      }

      return (
        <Col
          span={Math.round(24 / columns)}
          key={item.photo_id || item.live_id || item.object_id}
          className={classnames({ hidden: isHidden })}
        >
          <VideoItemComponent
            {...this.props}
            {...draggingProps}
            dragging={draggingItem === item}
            video={item}
          />
        </Col>
      )
    })
  }

  render() {
    const { gutter } = this.props

    return (
      <div
        className="video-list"
        onMouseUp={this.onMouseUp}
        onMouseLeave={this.onMouseUp}
        onMouseMove={this.onMouseMove}
      >
        <Row type="flex" gutter={gutter}>
          {this.renderVideoItems()}
          {this.addVideoButton()}
        </Row>
        {this.seeAllVideos()}
      </div>
    )
  }
}

VideoList.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object).isRequired,
  columns: PropTypes.number,
  reorderable: PropTypes.bool,
  onOrderChange: PropTypes.func,
  addVideoButton: PropTypes.bool,
  showAsSingleLine: PropTypes.bool,
  onAddVideoButtonClick: PropTypes.func,
  gutter: PropTypes.number,
  onClick: PropTypes.func,
}

VideoList.defaultProps = {
  columns: 6,
  gutter: 8,
  showAsSingleLine: false,
  reorderable: false,
  addVideoButton: false,
  onOrderChange: () => {},
}

export default VideoList
